exports.default = {
  'cancel': '取 消',
  'confirm': '確 定',
  'confirm_upload': '確認上傳',
  'submit': '提 交',
  'copy_success': '複製成功',
  'copy_failed': '複製失敗，請稍後重試！',
  'delete': '刪除',
  'upload_image': '上傳圖片',
  'copy': '複製',
  'close': '關 閉',
  'operation_failed': '操作失敗，請稍後重試',
  'operation_success': '操作成功！',
  'form_not_complete': '表單填寫不完整，請檢查後重新提交！',
  'executing': '執行中...',
  'crop_image': '裁剪圖片',
  'crop': '裁剪',
  'tips': '提 示',
  'refresh': '刷 新',
  'upload_without_crop': '不裁剪直接上傳',
  'save_success': '保存成功！',
  'image_type_error': '圖片類型必須是.gif,jpeg,jpg,png,bmp中的一種',
  'add_success': '添加成功',
  'verification_failed': '驗證碼校驗失敗',
  'loading': '加載中',
  'no_more': '沒有更多了',
  'your_agents': '您的智能體',
  'edit_avatar': '修改頭像',
  'save_note': '保存筆記',
  'share': '分享',
  'network_error': '網絡錯誤，發送失敗。',
  'single_image_size_no_more_than_50M': '單張圖片大小不超過20M，最多同時上傳10張圖片。',
  'please_enter_your_question_or_requirement': '請輸入你的問題或需求。按Enter發送消息，Ctrl+Enter / Shift+Enter換行',
  'account_logout_need_relogin': '當前賬號已被退出，請重新登錄',
  'account_identity_changed_refresh_required': '當前登錄賬號身份已變更，請刷新後重試',
  'team_disbanded_switch_notice': '當前團隊已解散，3秒後將自動切換到您的個人團隊。',
  'team_membership_lost_switch_notice': '您已不再屬於當前團隊，3秒後將自動切換到您的個人團隊。',
  'invalid_webpage': '無效的網頁'
}
